// extracted by mini-css-extract-plugin
export default {"welfare-count-down-box":"welfare-count-down-box_GlVpb","welfareCountDownBox":"welfare-count-down-box_GlVpb","count":"count_jikBa"};